var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"CustomSMSButton d-flex align-items-center justify-content-center pointer",on:{"click":function($event){return _vm.toggleModal('ShowPaystack')}}},[_c('img',{attrs:{"src":require("../../assets/paystack_edited.png"),"alt":"paystack","width":"12","height":"12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }